// extracted by mini-css-extract-plugin
module.exports = {"hiddenInput":"inputs_hiddenInput__BYD2S","isDisabled":"inputs_isDisabled__3omw5"};